// extracted by mini-css-extract-plugin
module.exports = {"footer":"BenefitsForHoldersModal_footer__33xgq","label":"BenefitsForHoldersModal_label__3ILle","benefits-container":"BenefitsForHoldersModal_benefits-container__1U7UE"};